import { Controller } from 'stimulus'

// Toggles visibility of named tab panels and styles the matching tab button.
// Each tab and panel carries a `data-key` attribute; clicking a tab sets
// `activeValue`, which the value-changed callback uses to update the DOM.
export default class extends Controller {
  static values = { active: String }
  static targets = ['tab', 'panel']

  declare activeValue: string
  declare tabTargets: HTMLElement[]
  declare panelTargets: HTMLElement[]

  select(event: Event) {
    const key = (event.currentTarget as HTMLElement).dataset.key
    if (key) {
      this.activeValue = key
    }
  }

  activeValueChanged() {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.key === this.activeValue
      tab.classList.toggle('text-accent', isActive)
      tab.classList.toggle('border-accent', isActive)
      tab.classList.toggle('border-b-2', isActive)
      tab.classList.toggle('text-base-content', !isActive)
      tab.setAttribute('aria-selected', String(isActive))
    })
    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.key === this.activeValue
      panel.classList.toggle('hidden', !isActive)
    })
  }
}
